import { EditOutlined } from '@ant-design/icons';
import { Button, Flex, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

import { EDIT_CATEGORY_PATH } from '@app/constants';
import { ArchiveLabel } from '@app/shared/components';
import type { NClientServices } from '@app/types';

import type { GetColumnType } from '@pages/ServiceCategories/types';

import type { ColumnsType } from 'antd/es/table';

export const getServiceCategoriesColumns: GetColumnType = ({
  onEdit,
  hasUserRightToEdit,
}) => {
  const editColumns: ColumnsType<NClientServices.Category> = hasUserRightToEdit
    ? [
        {
          title: null,
          key: 'Action',
          dataIndex: 'Action',
          width: 48,
          fixed: 'right',
          render: (_: unknown, row: NClientServices.Category) => {
            const isDeleted = row?.IsDeleted;

            if (isDeleted) {
              return null;
            }

            return (
              <Tooltip title="Редактировать">
                <Button
                  icon={<EditOutlined />}
                  data-testid="edit-service"
                  onClick={() => onEdit(row?.Id)}
                />
              </Tooltip>
            );
          },
        },
      ]
    : [];

  const basicColumns: ColumnsType<NClientServices.Category> = [
    {
      title: 'Название',
      dataIndex: 'Name',
      key: 'Name',
      ellipsis: true,
      render: (text: string, row: NClientServices.Category) => {
        const isDeleted = row?.IsDeleted;

        const Tag = isDeleted ? 'span' : Link;
        return (
          <Flex vertical align="start" gap={4}>
            <Tag
              to={`${EDIT_CATEGORY_PATH}?id=${row?.Id}`}
              data-testid="service-name"
            >
              {text}
            </Tag>
            {isDeleted && <ArchiveLabel />}
          </Flex>
        );
      },
    },
    {
      title: 'Описание',
      dataIndex: 'Description',
      key: 'Description',
      width: '40%',
      render: (text: string) => (
        <span data-testid="service-descriptions" className="no-wrap-text">
          {text}
        </span>
      ),
    },
  ];

  const columns: ColumnsType<NClientServices.Category> = [
    ...basicColumns,
    ...editColumns,
  ];

  return columns;
};
